import { render, staticRenderFns } from "./ClientFormStepper.vue?vue&type=template&id=5b9dc37a"
import script from "./ClientFormStepper.vue?vue&type=script&lang=js"
export * from "./ClientFormStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperItems})
